import { Button } from '@/components/ui/button';
import { AlertTriangle, RotateCw, Wrench } from 'lucide-react';
import type { DraftErrorState } from '@/lib/workflowStreamProtocol';

interface DraftErrorCardProps {
  error: DraftErrorState;
  stepName: string;
  onRetry?: () => void;
  onOpenInPromptBuilder?: () => void;
}

const FRIENDLY_HEADLINE: Record<DraftErrorState['kind'], string> = {
  timeout: 'That took too long.',
  network: 'Connection problem.',
  rate_limit: 'Too many requests right now.',
  usage_limit: 'Usage limit reached.',
  server_error: 'Cosmo had a server hiccup.',
  unknown: "Something didn't work.",
};

export function DraftErrorCard({ error, stepName, onRetry, onOpenInPromptBuilder }: DraftErrorCardProps) {
  return (
    <div className="rounded-xl border border-destructive/40 bg-destructive/5 p-4 space-y-3">
      <div className="flex items-start gap-3">
        <div className="h-8 w-8 rounded-full bg-destructive/10 flex items-center justify-center shrink-0">
          <AlertTriangle className="h-4 w-4 text-destructive" />
        </div>
        <div className="space-y-1 min-w-0">
          <p className="text-sm font-medium">
            {FRIENDLY_HEADLINE[error.kind]}
          </p>
          <p className="text-xs text-muted-foreground">
            Couldn't draft the prompt for <span className="font-medium text-foreground">{stepName}</span>. {error.message}
          </p>
        </div>
      </div>
      <div className="flex items-center justify-end gap-1.5">
        {onOpenInPromptBuilder && (
          <Button variant="outline" size="sm" onClick={onOpenInPromptBuilder} className="h-7 text-xs gap-1">
            <Wrench className="h-3 w-3" />
            Build manually
          </Button>
        )}
        {error.retryable && onRetry && (
          <Button size="sm" onClick={onRetry} className="h-7 text-xs gap-1">
            <RotateCw className="h-3 w-3" />
            Retry
          </Button>
        )}
      </div>
    </div>
  );
}
